import { getVND } from '@/utils/helpers'
import { Typography } from '@mui/material'
import parser from 'html-react-parser'
import React, { ReactNode } from 'react'

export const formatDiscountLabel = (discountItem: IDiscount): ReactNode => {
  // Kiểm tra nếu label không chứa placeholder
  if (!discountItem?.label.includes('{{var discount}}')) {
    return parser(discountItem?.label || '')
  }

  const { amount, type, discount_amount } = discountItem

  // Tạo nội dung hiển thị dựa trên type
  const getDiscountValue = (): string => {
    // Nếu type là by_percent, hiển thị cả phần trăm và giá tiền
    if (type === 'by_percent') {
      return `${discount_amount}% (${getVND(amount.value)})`
    }

    // Nếu type null hoặc khác by_percent, chỉ hiển thị giá tiền
    return `${getVND(amount.value)}`
  }

  const discountValue = getDiscountValue()

  // Split label theo placeholder và tạo array các phần
  const parts = discountItem?.label.split('{{var discount}}')

  // Tạo ReactNode với phần giảm giá được highlight
  return (
    <>
      {parts.map((part, index) => {
        return (
          <React.Fragment key={index}>
            {parser(part)}
            {index < parts.length - 1 && (
              <Typography
                component={'span'}
                sx={{
                  color: 'success.main',
                  fontSize: {
                    xs: '0.75rem',
                    md: '0.875rem',
                  },
                  fontWeight: 600,
                }}
              >
                {discountValue}
              </Typography>
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}
